// 妖精动漫网 - 常见问题数据
export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: '如何快速查找某位角色的配音演员？',
    answer: '您可以前往「声优表」页面，按角色名或作品名直接检索；也可在角色百科详情页的「出演信息」栏中，一键查看该角色对应的声优及其代表作。本站声优与角色的映射资料集中整理，查找高效。',
  },
  {
    question: '角色人气榜是如何产生的？',
    answer: '人气榜根据用户收藏、浏览热度与社区评分综合计算，每周更新。首页与角色百科页均会展示前 10 名，数据仅供参考与讨论，不代表角色本身的价值高低。',
  },
  {
    question: '网站收录了哪些类型的妖精角色？',
    answer: '本站聚焦「妖精 / 精灵类」动漫作品，按森林精灵、花之妖精、星之精灵、暗夜精灵、元素精灵、幻兽精灵六大类整理，并提供按作品、按元素标签的二次筛选，方便按需查阅动漫人物介绍。',
  },
  {
    question: '角色资料可以转载或引用吗？',
    answer: '部分文字资料整理自公开信息与社区讨论，引用时请注明来源「妖精动漫网」。商用转载建议先与我们联系获取授权，以尊重创作者的整理成果。',
  },
  {
    question: '如何反馈角色资料中的错误或补充新角色？',
    answer: '您可以通过页面底部「联系我们」邮箱提交纠错或补充建议，我们会在核实后尽快更新资料。感谢每一位参与共建的爱好者，让角色百科更完整。',
  },
  {
    question: '声优表多久更新一次？',
    answer: '随着新作开播与配音阵容公布，我们会持续同步声优出演信息，通常在新番开播后的 1～2 周内完成收录，确保资料新鲜可靠。',
  },
];